/**
 * Najczęstsze pytania przy pozycji oferty — mini-lista rozwijana, jedno
 * pytanie otwarte naraz (to jest lektura, nie porównanie).
 */

import { useState } from 'react';

import type { PytanieOdpowiedz } from '../../lib/oferta/karta';

import { Rozwijak } from './Rozwijak';

interface Props {
  id: string;
  pytania: PytanieOdpowiedz[];
  maks?: number;
}

export function PytaniaIOdpowiedzi({ id, pytania, maks = 6 }: Props) {
  const [otwarte, setOtwarte] = useState<number | null>(null);
  const lista = pytania.filter((p) => p.pytanie?.trim() && p.odpowiedz?.trim()).slice(0, maks);
  if (lista.length === 0) return null;

  return (
    <div className="divide-y divide-aurora-border border border-aurora-border rounded-ids-md">
      {lista.map((p, i) => (
        <Rozwijak
          key={`${id}-${i}`}
          id={`${id}-faq-${i}`}
          otwarty={otwarte === i}
          onToggle={() => setOtwarte(otwarte === i ? null : i)}
          klasaPrzycisku="px-3 py-2.5 min-h-[44px] items-center"
          naglowek={<span className="text-[13.5px] font-medium text-aurora-text">{p.pytanie}</span>}
        >
          <p className="px-3 pb-3 text-[13.5px] text-aurora-muted leading-relaxed whitespace-pre-line">
            {p.odpowiedz}
          </p>
        </Rozwijak>
      ))}
    </div>
  );
}
